/*
 * LMMM — ouverture de la question FAQ visée par l'ancre de l'URL (2026-09-02).
 *
 * Les liens de la recherche interne pointent vers /pages/faq#faq-<handle>
 * (cf. sections/faq-search-index.liquid). Le <details> correspondant est fermé
 * par défaut : on l'ouvre, puis on y défile (scroll-margin-top posé en CSS par
 * sections/faq-category.liquid, sous l'en-tête sticky). Rejoué sur `hashchange`
 * pour les liens internes à la page.
 *
 * Chargé par chaque section faq-category (même URL → un seul téléchargement) ;
 * le garde-fou ci-dessous évite d'empiler les écouteurs.
 */
(function () {
  if (window.__lmmmFaqAnchorInit) return;
  window.__lmmmFaqAnchorInit = true;

  function openFromHash() {
    var hash = window.location.hash;
    if (!hash || hash.indexOf('#faq-') !== 0) return;
    var details;
    try {
      details = document.getElementById(decodeURIComponent(hash.slice(1)));
    } catch (e) {
      return;
    }
    if (!details || details.tagName !== 'DETAILS') return;
    details.open = true;
    // AOS (data-aos) décale les blocs à l'arrivée : on laisse un tour de rendu passer.
    window.requestAnimationFrame(function () {
      details.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var summary = details.querySelector('summary');
      if (summary) summary.focus({ preventScroll: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openFromHash);
  } else {
    openFromHash();
  }
  window.addEventListener('load', openFromHash);
  window.addEventListener('hashchange', openFromHash);
})();
